import { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { updateAccessToken, clearAccessToken } from '../../actions/authenticationActions';
import { TANGO_CLIENT_ID } from '../../constants';
import { setCachedAuth0AccessToken } from '../../auth/auth0TokenBridge';

const AUTH_TOKEN_STORAGE_KEY = 'authToken';

const ExternalTokenListener = (props) => {
  const {
    updateAccessToken,
    clearAccessToken,
    isTangoClient,
  } = props;

  useEffect(() => {
    const onMessage = (event) => {
      const accessToken = event && event.data ? event.data.accessToken : null;
      const isValidToken = accessToken && accessToken.length >= 20;

      if (!isTangoClient && isValidToken) {
        sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, accessToken);
        setCachedAuth0AccessToken(accessToken);
        updateAccessToken(accessToken);
      }

      if (event && event.data && event.data.logout) {
        sessionStorage.clear();
        localStorage.clear();
        clearAccessToken();
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [updateAccessToken, clearAccessToken, isTangoClient]);

  return null;
};

ExternalTokenListener.propTypes = {
  updateAccessToken: PropTypes.func.isRequired,
  clearAccessToken: PropTypes.func.isRequired,
  isTangoClient: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    isTangoClient: state.clientId === TANGO_CLIENT_ID,
  }),
  {
    updateAccessToken,
    clearAccessToken,
  }
)(ExternalTokenListener);